import { Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { UIBadgeVariant } from '@fry/ui/badge/badge.component';

import { InheritableType } from '../is-inheritable/is-inheritable.model';


@Component({
    selector: 'eas-editor-booking-item-inheritable-type-badge',
    template: `<app-badge [variant]="badgeConfig.variant" [title]="badgeConfig.title"></app-badge>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemInheritableTypeBadgeComponent implements OnChanges, OnInit {
  @Input() inheritableType: InheritableType;

  badgeConfig: { variant: UIBadgeVariant, title: string };

  constructor() {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.inheritableType) {
      this.badgeConfig = this.getBadgeConfig();
    }
  }

  private getBadgeConfig(): { variant: UIBadgeVariant, title: string } {
    switch (this.inheritableType) {
      case 'empty':
        return {
          variant: 'none',
          title: $localize `empty`
        };
      case 'set':
        return {
          variant: 'success',
          title: $localize `set`
        };
      case 'inherited':
      case 'inherited-overridden':
        return {
          variant: 'warning',
          title: $localize `inherited`
        };
      case 'overridden':
        return {
          variant: 'danger',
          title: $localize `overridden`
        };
    }
  }
}
